export default __webpack_public_path__ + "static/media/jpg.beddeefe.svg";